/**
 *  This class returns the info about a user who has been successfully logged in
 */

import Result from './Result';

class MutualUserResult extends Result {
	private _mutualID: string;
	private _firstName: string;
	private _lastName: string;
	private _photo: string;
	private _premium: boolean;

	/**
	 * @param success whether the request was successfully
	 * @param message contains the error if the request was unsuccessful
	 * @param mutualID the ID of the logged in user
	 * @param firstName the user's first name
	 * @param lastName the user's last name
	 * @param photo the photo on the user's profile
	 */
	constructor(
		success: boolean,
		message: string,
		mutualID: string,
		firstName: string,
		lastName: string,
		photo: string,
		premium: boolean
	) {
		super(success, message);
		this._mutualID = mutualID;
		this._firstName = firstName;
		this._lastName = lastName;
		this._photo = photo;
		this._premium = premium;
	}

	get mutualID(): string {
		return this._mutualID;
	}

	set mutualID(value: string) {
		this._mutualID = value;
	}

	get firstName(): string {
		return this._firstName;
	}

	set firstName(value: string) {
		this._firstName = value;
	}

	get lastName(): string {
		return this._lastName;
	}

	set lastName(value: string) {
		this._lastName = value;
	}

	get photo(): string {
		return this._photo;
	}

	set photo(value: string) {
		this._photo = value;
	}

	set premium(value: boolean) {
		this._premium = value;
	}

	get premium(): boolean {
		return this._premium;
	}
}

export default MutualUserResult;
